import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {CongenereEligibilityStore} from './types';

export const useCongenereEligibilityStore = create<CongenereEligibilityStore>()(
	persist(
		set => ({
			congenereEligibility: false,
			congenereDrawerDismissedDate: '',
			setCongenereEligibility: value => set({congenereEligibility: value}),
			setCongenereDrawerDismissedDate: value => set({congenereDrawerDismissedDate: value}),
			resetCongenereEligibility: () =>
				set({congenereEligibility: false, congenereDrawerDismissedDate: ''}),
		}),
		{name: 'congenereEligibilityStore'},
	),
);
